import React from 'react';
import { bonuses } from '../../data/content';
import { SectionLabel } from '../ui/SectionLabel';
export function Bonuses() {
  return <section aria-labelledby="bonos-title" className="w-full bg-ink-850" data-id="element-17" data-mp="1hiptna4tfrqf">
      <div className="mx-auto max-w-5xl px-5 py-16 md:py-20" data-id="element-18" data-mp="1cm7q2dl81zfo">
        <div className="max-w-3xl" data-id="element-19" data-mp="18jkvw612w2fb">
          <SectionLabel data-id="element-20" data-mp="18km6yai3gox1">Incluidos hoy sin costo adicional</SectionLabel>
          <h2 id="bonos-title" className="mt-5 font-display text-3xl font-black leading-tight text-white md:text-4xl" data-id="element-21" data-mp="259lefnautmo6">
            Bonos estratégicos para potenciar cada decisión que tomás
          </h2>
        </div>
        <p className="mt-8 rounded-xl bg-pitch px-6 py-5 text-center text-base font-bold text-white" data-id="element-22" data-mp="1w7lzr1nbauoe">
          Valor total de los bonos: <span className="text-subtle line-through" data-id="element-23" data-mp="1rcf1wagq4k7e">$29.980</span>{' '}
          <span className="text-brand-green" data-id="element-24" data-mp="kvbcfarc7qrc">— hoy incluidos gratis</span>
        </p>
        <div className="mt-6 grid gap-5 md:grid-cols-2" data-id="element-25" data-mp="fu41x3xt8dgz">
          {bonuses.map(bonus => <article key={bonus.number} className="flex h-full flex-col rounded-xl border border-ink-border bg-ink-card p-6 shadow-panel transition-colors duration-150 ease-out hover:border-brand-green" data-id="element-26" data-mp="1euydg3jnmbbs">
              <div className="flex flex-wrap items-center gap-3" data-id="element-27" data-mp="1as1s452qc145">
                <span className="rounded-full bg-brand-gold/10 px-3 py-1 text-xs font-black uppercase tracking-[0.12em] text-brand-gold" data-id="element-28" data-mp="1aq8iqi0qf2sg">
                  {bonus.number}
                </span>
                <span className="text-xs font-semibold text-subtle line-through" data-id="element-29" data-mp="10vgjl9ri47vk">
                  {bonus.originalPrice}
                </span>
                <span className="rounded-full bg-brand-greenDeep px-3 py-1 text-xs font-bold text-brand-greenSoft" data-id="element-30" data-mp="r3t0px90fz5p">
                  Gratis hoy
                </span>
              </div>
              <h3 className="mt-4 font-display text-xl font-bold text-white" data-id="element-31" data-mp="d6noffipe420">{bonus.title}</h3>
              <p className="mt-3 text-[15px] leading-relaxed text-body" data-id="element-32" data-mp="i58lx76km9mr">{bonus.description}</p>
            </article>)}
        </div>
      </div>
    </section>;
}